/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectLoggedInData, setLoginData } from '../store/slices/api/auth/loginSlice'
import { NAVIGATION } from '../lib/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash'

export default function ProtectedRoutes({ children }) {
    const loggedInData = useSelector(selectLoggedInData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location?.pathname;

    const validateRoutes = (currentRoute) => {
        const authUserData = localStorage.getItem('authUserData') ? JSON.parse(localStorage.getItem('authUserData')) : '[]';
        if (authUserData) {
            const currentRouteKey = _.find(JSON.parse(authUserData?.admin_roles), { href: currentRoute });
            if (currentRouteKey) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const isLoggedIn = async () => {
        const authToken = localStorage.getItem("authToken");
        const authUserData = localStorage.getItem('authUserData') ? JSON.parse(localStorage.getItem('authUserData')) : null;
        try {
            if (authToken && authUserData) {
                const loggedInUserData = {
                    authToken,
                    authUserData
                }
                if (currentPath === '/login' || currentPath === '/dashboard' || currentPath === '/logout') {
                    dispatch(setLoginData({ ...loggedInUserData }))
                } else {
                    if (authUserData?.admin_user_type === 'subadmin') {
                        if (validateRoutes(currentPath)) {
                            dispatch(setLoginData({ ...loggedInUserData }))
                        } else {
                            navigate(NAVIGATION.INNER_NAVIGATION.DASHBOARD);
                        }
                    } else {
                        dispatch(setLoginData({ ...loggedInUserData }))
                    }
                }
            } else {
                localStorage.clear();
                dispatch(setLoginData(null));
                navigate(NAVIGATION.AUTH_NAVIGATION.LOGIN);
            }
        } catch (error) {
            dispatch(setLoginData(null))
            console.log("Error while Logging you in : ", error);
        }
    };

    useEffect(() => {
        isLoggedIn();
    }, []);
    return (
        <>
            {
                loggedInData && children
            }
        </>
    )
}
